import { Component, OnInit } from '@angular/core';

import * as _ from 'lodash';
import { AttributesComponent } from '../attributes.component';
import { AttributesStatisticCollectionNames } from 'src/shared/enums';
import { CalibrationSetAttributesPopupComponent } from '../attributes-popup/calibration-set-attributes-popup/calibration-set-attributes-popup.component';
import { IAttributePopupEntityParams } from 'src/app/interfaces/attribute-popup-params.interface';

@Component({
    standalone: false,
    selector: 'calibration-set-attributes',
    templateUrl: '../attributes.component.html',
    styleUrls: ['../attributes.component.scss']

})
export class CalibrationSetAttributesComponent extends AttributesComponent implements OnInit {
    ngOnInit() {
        super.ngOnInit();
        this.entityName = AttributesStatisticCollectionNames.CALIBRATION_SETS_ATTRIBUTES_STATISTICS;
        this.popupComponent = CalibrationSetAttributesPopupComponent;
    }

    getParameters(): IAttributePopupEntityParams {
        return {
            ParentId: this.calibrationSetId,
            ParentType: this.calibrationSetType,
            Typology: this.typology
        };
    }
}
